import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { DropdownDirection, ShBaseFormComponent } from '@stylehaven/components';

@Component({
    selector: 'med-form-permissions',
    templateUrl: './form-permissions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormPermissionsComponent extends ShBaseFormComponent implements OnInit {
    @Input() readLabel: string;
    @Input() writeLabel: string;
    @Input() exportLabel: string;

    @Input() noneSelectedMsg: string;
    @Input() multipleSelectedMsg: string;
    @Input() allSelectedMsg: string;

    @Input() isBatchEdit?: boolean = false;

    @Input() openDirection: DropdownDirection = DropdownDirection.Below;
}
